module.exports = __webpack_public_path__ + "img/no_image_large.637c6896.png";